import { routes } from '@/webapi/routes';
import { SavedStrategies } from './saved-filters';

type Fetcher = (url: string) => Promise<any>;

const maxPage = 15;

const fetchStrategiesPage = async (
  get: Fetcher,
  page: number,
): Promise<{ strategies: SavedStrategies; total: number }> => {
  const response = await get(`${routes.getListSlotsStrategies}?page=${page}`);

  const strategies = (response?.strategies || []).map((s: any) => ({
    ...s,
    slots: s.slots?.slots || [],
  }));

  return {
    strategies,
    total: response?.total || 0,
  };
};

export const fetchAllStrategies = async (
  get: Fetcher,
): Promise<SavedStrategies> => {
  const { strategies: firstPage, total } = await fetchStrategiesPage(get, 0);

  if (firstPage.length >= total) {
    return firstPage;
  }

  const pageSize = firstPage.length;

  if (pageSize === 0) {
    return firstPage;
  }

  const totalPages = Math.min(Math.ceil(total / pageSize), maxPage);

  const remainingPages = Array.from({ length: totalPages - 1 }, (_, i) =>
    fetchStrategiesPage(get, i + 1),
  );

  const results = await Promise.all(remainingPages);

  return [...firstPage, ...results.flatMap((r) => r.strategies)];
};
